import * as Event from '../../events';
import ArticleModel from '../../model/article-model';
import {isEmpty,isNull} from 'lodash';
import UIkit from '../../../uikit';
import * as GHPages from '../../config/ghpages';
import DateFormater from '../../utility/dateformater';
import {setEditorById} from '../../config/ckeditor';

/**
 * Administrator - Article
 * 
 * @author wadahkode <mvp.dedefilaras@gmail.com>
 * @since version v1.0.85
 */
class Article extends ArticleModel {
    constructor(table) {
        super(table);
        this.photoTmp = "";
    }
    
    create() {
        let form = document.getElementById('form-article-create'),
            buttonSave = document.querySelector('.quick-btn-create-article'),
            buttonDraft = document.querySelector('.quick-btn-draft-article');
        
        form.articleTitle.addEventListener("keyup",function(){
            let val = this.value;
            form.articleUrl.value = val.split(' ').join('-').toLowerCase();
        });
        
        // replace textarea to ckeditor
        const editor = setEditorById(document.querySelector('#editor'));
        
        form.querySelector('.js-upload').addEventListener('change', () => {
            this.previewPhoto(form.querySelector('.articlePhoto'));
        });
        
        buttonSave.addEventListener('click', () => {
            buttonSave.setAttribute("disabled", true);
            buttonSave.innerHTML = `
                <span class="spinner"></span>
                <span>&nbsp;Please wait...</span>
            `;
            form.onsubmit = this.handleCreateArticle(form, buttonSave, editor);
        });
        
    }

    handleCreateArticle(form, btn, editor) {
        const {
            articleTitle,
            articleHostname,
            articleUrl,
            articleContent
        } = form;
        
        var validate = this.validation(form, editor),
            date = new DateFormater(new Date()),
            now = date.halfTime(),
            auth = this.auth,
            saveArticle;
            
        validate.then(status => {
            if (status) {
                saveArticle = this.saveArticle({
                    "articleTitle": articleTitle.value,
                    "articleUrl": articleHostname.value + articleUrl.value,
                    "articleContent": articleContent.value,
                    "articlePhoto": isEmpty(this.photoTmp) ? GHPages.getOrigin().origin + GHPages.getOrigin().pathname + '/assets/avatar/no-image.png' : this.photoTmp,
                    "articleKey": this.articleKey,
                    "author": !isNull(auth.displayName) ? auth.displayName : auth.email,
                    "photoAuthor": !isEmpty(auth.photoURL) ? auth.photoURL : GHPages.getOrigin().origin + GHPages.getOrigin().pathname + '/assets/avatar/no-image.png',
                    "created_at": now,
                    "updated_at": now
                });
            }
        });
        
        const previewPhoto = document.getElementById('preview-photo');
        setTimeout(function() {
            if (saveArticle) {
                btn.disabled = false;
                btn.innerHTML = "Pajang sekarang";
                previewPhoto.src = "";
                previewPhoto.className = "";
                form.reset();
                editor.then(e => {
                    e.setData("");
                });
            } else {
                btn.disabled = false;
                btn.innerHTML = "Pajang sekarang";
                editor.then(e => {
                    e.setData("");
                });
            }
        }, 3000);
    }
    
    index() {
        const article = document.getElementById('view-article'),
            viewArticle = "";
            
        if (isNull(article)) {
            return false;
        }
        article.innerHTML = `
            <thead>
                <th>Judul artikel</th>
                <th>Link</th>
                <th>Isi artikel</th>
                <th>Foto artikel</th>
                <th>Aksi</th>
            </thead>
        `;
        
        const getArticle = this.getArticle(articleItem => {
           article.innerHTML += this.viewArticle(articleItem);
        });
        
        //this.getArticle((articleItem,key) => {
        //    article.innerHTML += this.viewArticle(articleItem, key);
        //});
    }
    
    previewPhoto(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader(),
            photo = document.getElementById('preview-photo');
            
            reader.onload = (e) => {
                this.photoTmp = e.target.result;
                photo.src = e.target.result;
                //photo.width = 144;
                //photo.height = 144;
                photo.className = "uk-height-large";
                //photo.setAttribute("uk-img","");
            };
            reader.readAsDataURL(input.files[0]); // convert to base64 string
        }
    }
    
    validation(...input) {
        const {
            articleTitle,
            articleUrl,
            articleContent
        } = input[0];
        
        let editor = input[1];
        
        return editor.then(snapshot => {
            articleContent.value = snapshot.getData();
            
            if (isEmpty(articleTitle.value)) {
                UIkit.notification("Judul artikel tidak boleh kosong!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            else if (isEmpty(articleContent.value)) {
                UIkit.notification("Isi artikel tidak boleh kosong!", {
                    status: 'warning',
                    timeout: 2000
                });
            }
            // else if (isEmpty(articleContent.value)) {
            //     UIkit.notification("Isi artikel tidak boleh kosong!", {
            //         status: 'warning',
            //         timeout: 2000
            //     });
            // }
            else {
                //input[0].articleContent.value = snapshot.getData();
                
                return true;
            }
        });
    }
    
    viewArticle(item, key) {
        return `
            <tbody>
                <td>${item.articleTitle}</td>
                <td><a href="${item.articleUrl}">${item.articleUrl}</a></td>
                <td>${item.articleContent.substring(0,32)}...</td>
                <td><img src="${item.articlePhoto}" width="32" height="32"/></td>
                <td>
                    <a href="${item.articleKey}" class="uk-button uk-button-small uk-button-primary">edit</a>
                    <a href="${item.articleKey}" class="uk-button uk-button-small uk-button-danger">hapus</a>
                </td>
            </tbody>
        `;
    }
}

export default Article;
